const sortOptions = [
  {
    id: 'featured',
    label: 'featuredLabel',
    sortFunction: (resultA, resultB) => 0,
    showOn: ['accessories'],
  },
  {
    id: 'price-asc',
    label: 'priceAscendingLabel',
    sortFunction: (resultA, resultB) => resultA.price - resultB.price,
    showOn: ['accessories'],
  },
  {
    id: 'price-desc',
    label: 'priceDescendingLabel',
    sortFunction: (resultA, resultB) => resultB.price - resultA.price,
    showOn: ['accessories'],
  },
  {
    id: 'name-asc',
    label: 'nameAscendingLabel',
    sortFunction: (resultA, resultB) => {
      const resultAName = resultA.name.toLowerCase();
      const resultBName = resultB.name.toLowerCase();

      if (resultAName > resultBName) {
        return 1;
      }

      if (resultBName > resultAName) {
        return -1;
      }

      return 0;
    },
    showOn: ['accessories'],
  },
  {
    id: 'name-desc',
    label: 'nameDescendingLabel',
    sortFunction: (resultA, resultB) => {
      const resultAName = resultA.name.toLowerCase();
      const resultBName = resultB.name.toLowerCase();

      if (resultAName > resultBName) {
        return -1;
      }

      if (resultBName > resultAName) {
        return 1;
      }

      return 0;
    },
    showOn: ['accessories'],
  },
];

export default sortOptions;
